module.exports = "/_next/static/images/new-logo-green-aab5a8b21f782e4f1a80a0a5de129f87.svg";